import {
  ProjectsDetailSection,
  ProjectsHeaderSection,
  StyledActivityCardBackground
} from 'modules';



export type ProjectsActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const ProjectsActivity = (props: ProjectsActivityProps) => {

  return (
    <StyledActivityCardBackground.FC>
      <ProjectsHeaderSection.FC />
      <ProjectsDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
